import React from "react";
import Button from "../../../independent/Button";
import {selectShouldCloseAllOnConfirm} from "../../../../redux/modal-slice/modalSlice";
import {useSelector} from "react-redux";

const Alert = ({title, closeSubModal, message, callback, closeModal}) => {
  const shouldCloseAllOnConfirm = useSelector(selectShouldCloseAllOnConfirm);

  const handleConfirm = () => {
    if (callback) {
      callback();
    }

    closeSubModal();

    if (shouldCloseAllOnConfirm) {
      closeModal();
    }
  };


  return (
    <div>
      <div className={"modal-header"}>
        <h2>{title}</h2>
        <button type="button" className="modal-close" onClick={closeSubModal}>
          close
        </button>
      </div>
      <div className={"modal-body"}>
        {typeof message === 'string' ? <span style={{ whiteSpace : "pre-line"}}>{message}</span> : message}
      </div>
      <div className={"modal-footer"}>
        <div className={"delete-history-buttons"}>
          <Button name={"OK"}
                  block={true}
                  confirm={true}
                  onClick={handleConfirm}
          />
        </div>
      </div>
    </div>
  )
}

export default Alert;
